import { ClientDetailsFormValues } from '@/pages/referClient/steps/1_ClientDetails/types'

export const CLIENT_DETAILS_FORM_FIELDS: Record<
  keyof ClientDetailsFormValues,
  keyof ClientDetailsFormValues
> = {
  partyType: 'partyType',
  partyName: 'partyName',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  telephone: 'telephone',
  dateOfBirth: 'dateOfBirth',
  addressLine1: 'addressLine1',
  city: 'city',
  postcode: 'postcode',
  clientId: 'clientId',
  circumstances: 'circumstances',
}
